import {withRouter} from "react-router-dom";
import {ENUM} from "../../core/utils/enum";
import CategoryMenu from "../menus/CategoryMenu";

function Menu({ user, location, history, setShowMenu }) {
    const paths = location.pathname.split('/');

    const onClick = (event) => {
        const selectedPath = event.currentTarget.dataset.to;
        if (paths[2] !== selectedPath) {
            history.push(selectedPath);
            setShowMenu(false);
        }
    };

    return (
        <>
            {paths[1] === ENUM.route.admin &&
                <>
                    <li onClick={onClick} data-to={`/${ENUM.route.admin}/${ENUM.route.articles}`} className={paths[2] === ENUM.route.articles ? 'selected' : ''}>Articles</li>
                    <li onClick={onClick} data-to={`/${ENUM.route.admin}/${ENUM.route.users}`} className={paths[2] === ENUM.route.users ? 'selected' : ''}>Users</li>
                    <li onClick={onClick} data-to={`/${ENUM.route.admin}/${ENUM.route.brands}`} className={paths[2] === ENUM.route.brands ? 'selected' : ''}>Brands</li>
                    <li onClick={onClick} data-to={`/${ENUM.route.admin}/${ENUM.route.categories}`} className={paths[2] === ENUM.route.categories ? 'selected' : ''}>Categories</li>
                    <li onClick={onClick} data-to={`/${ENUM.route.admin}/${ENUM.route.countries}`} className={paths[2] === ENUM.route.countries ? 'selected' : ''}>Countries</li>
                    <li onClick={onClick} data-to={`/${ENUM.route.admin}/${ENUM.route.retailers}`} className={paths[2] === ENUM.route.retailers ? 'selected' : ''}>Retailers</li>
                </>
            }
            {paths[1] === ENUM.route.market &&
                <CategoryMenu userId={user && user.id} location={location} selectedCategoryId={paths[2]} onClick={onClick} />
            }
        </>
    );
}
export default withRouter(Menu);
